import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { WEBHOOK_ENDPOINTS_QUERY_KEY } from "../webhooks/useWebhookEndpointsQuery";

/**
 * Hook to invalidate the webhook endpoints list.
 * Use this after creating, updating or deleting an endpoint.
 */
export const useInvalidateWebhookEndpoints = () => {
  const queryClient = useQueryClient();

  return useCallback(async () => {
    await queryClient.invalidateQueries({
      queryKey: [WEBHOOK_ENDPOINTS_QUERY_KEY]
    });
  }, [queryClient]);
};
